// extracted by mini-css-extract-plugin
export var TeamBio = "TeamBio-module--TeamBio--24FyB";
export var Quote = "TeamBio-module--Quote--1n-sc";
export var InfoBlock = "TeamBio-module--InfoBlock--2ArZa";
export var productInfoTable = "TeamBio-module--productInfoTable--39Lip";
export var infoTitle = "TeamBio-module--infoTitle--1ImiV";